<template>
  <div class="regressionPage">
    <div class="top-title">Regression Report</div>
    <!--   v-loading="loading"
        element-loading-text="Loading..." 
        :row-key="getRowKey"
         :width="flexTestCaseWidth(tableData)"
         -->
    <div class="bg">
      <div class="table-bg">
        <el-table
          stripe
          tooltip-effect="light"
          class="table"
          :data="tableData"
          ref="dragTable"
          :row-class-name="tableRowClassName"
          width="100%"
          border
          fit
          :header-cell-style="{
            background: '#F6F6F6',
            borderLeft: '0.5px solid #999999',
            borderRight: '0px solid #999999',
            borderTop: '0px solid #999999',
            borderBottom: '2px solid #999999',
          }"
          :cell-style="{
            background: '#FFFFFF',
            borderBottom: '0.5px solid #707070',
            borderRight: '0px solid #999999',
            borderLeft: '0.5px solid #999999',
          }"
          :max-height="getHeight()"
        >
          <el-table-column fixed width="60" align="center">
            <template #header>
              <div class="header-title header-no-item">NO.</div>
            </template>
            <template #default="scope">
              <div class="table-content table-no">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">Repository</div>
                <FiltrateOpsItem  :identifyTitle="headerIdentifyList[0]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
                <!-- <div class="header-icon">
                  <img src="@/assets/select-icon.png" />
                </div> -->
              </div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.repository }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">PR Number</div>
                <FiltrateOpsItem  :identifyTitle="headerIdentifyList[1]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
                <!-- <div class="header-icon">
                  <img src="@/assets/select-icon.png" />
                </div> -->
              </div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.prNumber }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">PR Title</div>
               <FiltrateOpsItem  :identifyTitle="headerIdentifyList[2]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
                <!-- <div class="header-icon">
                  <img src="@/assets/select-icon.png" />
                </div> -->
              </div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.prTitle }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">Owner</div>
                <FiltrateOpsItem  :identifyTitle="headerIdentifyList[3]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
                <!-- <div class="header-icon">
                  <img src="@/assets/select-icon.png" />
                </div> -->
              </div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.owner }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="180"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">Status</div>
                <FiltrateOpsItem  :identifyTitle="headerIdentifyList[4]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
                <!-- <div class="header-icon">
                  <img src="@/assets/select-icon.png" />
                </div> -->
              </div>
            </template>
            <template #default="scope">
              <div class="table-content" :style="{color: getStatusColor(scope.row.status), cursor: getStatusStyle(scope.row.status)}" @click="logDownloadDo(scope.row)">
                {{ getStatusTitle(scope.row) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-title header-item">Commit log</div>
            </template>
            <template #default="scope">
              <div class="table-content" :style="{color:'#0077FF'}">
                {{ scope.row.commitLog }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="165"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-title header-item">Start time</div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.startTime }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="165"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-title header-item">End time</div>
            </template>
            <template #default="scope">
              <div class="table-content">
                {{ scope.row.endTime }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-title header-item">Details</div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout" :style="{color:'#0077FF', cursor: getDetailsStyle(scope.row)}" @click="packageDownloadDo(scope.row)">
                {{ scope.row.details }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom-title">{{ getSum() }}</div>

      <!-- :show-close="false" -->
    <el-dialog
      v-model="centerDialogVisible"
      center
      :close-on-click-modal="false"
      @closed="escClose"
    >
      <div class="logBg">
        <textarea class="textBg" readonly v-model="logData"></textarea>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import FiltrateOpsItem from "@/components/FiltrateOpsItem.vue";
import { getOSSFileList, getOSSUrl } from "@/request/api";
import { getUrlData } from "@/request/axiosApi"
import { RegressionStatusType, RegressionFailureType } from "@/utils/common"
export default {
  name: "regressionPage",
  data() {
    return {
      headerIdentifyList: ["repository", "prNumber", "prTitle", "owner", "status"],
      centerDialogVisible: false,
      originDataList: [],
      tableData: [],
      logList: [],
      packageList: [],
      logData: "",
      originRepository: "",
      originPrNumber: ""
    };
  },
  methods: {
    getRegressionFailureType(failureType) {
      if (failureType?.toLocaleLowerCase().includes("build")) {
        return RegressionFailureType.build
      }
      else if (failureType?.toLocaleLowerCase().includes("regression")) {
        return RegressionFailureType.regression
      }
      return RegressionFailureType.none
    },
    getStatusType(status) {
      if (status?.toLocaleLowerCase().includes("failure")) {
        return RegressionStatusType.failure
      }
      return RegressionStatusType.success
    },
    getStatusTitle(item) {
      if (item.statusType == RegressionStatusType.failure) {
        if (item.failureType == RegressionFailureType.regression) {
          return "Regression Failure"
        } else if (item.failureType == RegressionFailureType.build) {
          return "Build Failure"
        }
      }
      return "Success"
    },
    getRowKey(row) {
      return row.testCase;
    },
    getStatusStyle(status) {
      const type = this.getStatusType(status)
      if (type == RegressionStatusType.failure) {
        return 'pointer'
      }
      return 'default'
    },
    getDetailsStyle(item) {
      if (item.statusType == RegressionStatusType.failure && item.failureType == RegressionFailureType.regression) {
        return 'pointer'
      }
      return 'default'
    },
    getStatusColor(status) {
      const type = this.getStatusType(status)
      if (type == RegressionStatusType.failure) {
        return '#0077FF'
      }
      return '#000000'
    },
    getHeight() {
      const h = `${document.documentElement.clientHeight}`;
      return h - 240;
    },
    getSum() {
      return this.tableData.length + "records";
    },
    //错位
    tableLayout() {
      this.$nextTick(() => {
        this.$refs.dragTable.doLayout();
      });
    },
    checkBoxSelect(item) {
      console.log("checkBoxSelect === ", item)
      // const list = [...this.originDataList]
      console.log("originDataList === ", this.originDataList)
      for (const model of this.originDataList) {
        // model.isSelected = true
        const selectTitle = model[item.identifyTitle]
        if (selectTitle == item.selectTitle) {
          model.isSelected = item.item.isSelected
        }
      }
      const ll = this.originDataList.filter((m) => {
        return (m.isSelected == true)
      })      
      this.tableData = ll
    },
    async logDownloadDo(model) {
      const type = this.getStatusType(model.status)
      if (type == RegressionStatusType.failure) {
        const ll = this.logList.filter(item => {
          return (item.name.includes(model.pathNumber) && item.name.includes(model.prNumber))
        })
        if (ll.length > 0) {
          const mm = ll.shift()
          const url = await getOSSUrl("icb-devops", mm.name)
          console.log(url)
          const data = await getUrlData(url)
          this.centerDialogVisible = true
          this.logData = data
        // const a = document.createElement("a")
        // a.href = url
        // a.download = mm.name
        // document.body.appendChild(a);
        // document.body.removeChild(a);
        // a.click()
        }
      }
    },

    async packageDownloadDo(model) {
      //(item.repository.includes(model.pathNumber) && item.name.includes(model.prNumber))
      const ll = this.packageList.filter(item => {
        return (item.repository == model.repository && item.pathNumber == model.pathNumber && item.prNumber == model.prNumber)
      })
      if (ll.length > 0) {
        const mm = ll.shift()
        const url = await getOSSUrl("icb-devops", mm.name)
        console.log(url)
        const a = document.createElement("a")
        a.href = url
        a.download = mm.name
        document.body.appendChild(a);
        document.body.removeChild(a);
        a.click()
      }
    }

  },
  components: {
    FiltrateOpsItem
  },  
  async created() {
    this.tableLayout();
    this.originRepository = "Eden"
    if (this.$route.query.repository) {
      this.originRepository = this.$route.query.repository
    }
    this.originPrNumber = this.$route.query.prNumber

    const list = await getOSSFileList(this.$DataString.regressionBucket, this.originRepository)
    console.log("list.objects = ", list.objects)
    this.logList = list.objects.filter((item) => {
      return item.name.includes(".log")
    })
    this.packageList = list.objects.filter((item) => {
      return item.name.includes(".tar") || item.name.includes(".gz") || item.name.includes(".zip")
    })
    this.packageList.map(item => {
      const arr = item.name.split("/")
      item.prNumber = arr[1]
      item.pathNumber = arr[2]
      arr.pop()
      item.repository = arr[0]//.join("/")
    })
    
    const list2 = list.objects.filter((item) => {
      return item.name.includes(".json")
    })
    list2.map(item => {
      const arr = item.name.split("/")
      item.prNumber = arr[1]
      item.pathNumber = arr[2]
      arr.pop()
      item.repository = arr[0]//.join("/")
    })
    list2.sort((m1, m2)=> {
      return m1.prNumber - m2.prNumber
    })
    const list3 = []
    if (this.originPrNumber) {
      list3.push(this.originPrNumber)
    } else {
      for (const item of list2) {
        list3.push(item.prNumber)
      }
    }
    const list4 = [... new Set(list3)]
    
    const dataList = []
    for (const prNumber of list4) {
      let maxItem = {}
      let maxPathNumber = 0
      for (const item of list2) {
        if (prNumber ==  item.prNumber) {
          if (item.pathNumber >= maxPathNumber) {
            maxPathNumber = item.pathNumber
            maxItem =  item
          }
        }
      }
      const url = await getOSSUrl(this.$DataString.regressionBucket, maxItem.name)
      console.log(url)
      const jsonModel = await getUrlData(url, true);
      maxItem.prTitle = jsonModel.pr_title
      maxItem.owner = jsonModel.head_owner
      // maxItem.status = jsonModel.status
      maxItem.statusType = this.getStatusType(jsonModel.status)
      maxItem.commitLog = jsonModel.commit_comment
      maxItem.startTime = jsonModel.start_time
      maxItem.endTime = jsonModel.end_time
      maxItem.startTime = jsonModel.start_time
      maxItem.failureType = this.getRegressionFailureType(jsonModel.failure_type)
      let details = ""
      //RegressionFailureType.regression RegressionFailureType.none
      if (maxItem.statusType == RegressionStatusType.failure && maxItem.failureType == RegressionFailureType.regression) {
        details = "Download"
      }
      maxItem.details = details
      maxItem.status = this.getStatusTitle(maxItem)
      maxItem.isSelected = true

      dataList.push(maxItem);
    }
    console.log("dataList = ", dataList)
    this.originDataList = dataList;
    this.tableData = [...this.originDataList]

  },
};
</script>
<style lang='less' scoped>
.regressionPage {

  .logBg {
    padding: 0px 20px;
    height: 380px;
    
    // overflow-y: auto;
    // overflow-x: hidden;
    // scroll-behavior: auto;
   
    
    .textBg {
      padding: 10px;
      width: 100%;
      height: 100%;
      resize: none;
      // line-height: 23px;
      font-size: 15px;
      color: #565656;
      word-break:break-all;
    }
  }
  .top-title {
    color: #0050b3;
    font-size: 32px;
    font-weight: bold;
    text-align: left;
    padding: 30px 0px 33px 85px;
  }
  .bg {
    height: calc(100vh - 240px);
    padding: 0px 81px 0px 81px;
    .table-bg {
      height: 100%;
      border: 1px solid #e8ebf3;
    }
    .table {
      border-top: 2px solid #707070;
      border-left: 0px solid #707070;
      border-right: 0.5px solid #707070;
      border-bottom: 1.5px solid #707070;
      border-radius: 4px;
      .header-title {
        color: #000000;
        font-size: 16px;
        font-weight: 700;
        // padding-left: 10px;
      }
      .header-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      .header-icon {
        height: 14px;
        width: 14px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .table-content {
        width: 100%;
        display: flex;
        height: 50px;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .table-no {
        justify-content: center;
      }
      .table-layout {
        cursor: pointer;
      }
      .details-title {
        cursor: pointer;
      }
    }
  }
  .bottom-title {
    display: flex;
    margin-left: 81px;
    width: calc(100% - 162px);
    height: 25px;
    background-color: #f3f6f9;
    text-align: left;
    padding-left: 20px;
    color: #565656;
    font-size: 14px;
    padding-left: 30px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;
  }
}
:deep(.el-table .cell) {
  padding: 0px 10px 0px 10px !important;
}
:deep(.el-table td) {
  padding: 0 !important;
}
:deep(.el-dialog) {
  border-radius: 8px;
  height: 460px !important;
  width: 800px !important;
}
:deep(.el-table th) {
  user-select: initial !important;
}
</style>